"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadCustomElementsReducers = void 0;
var tslib_1 = require("tslib");
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var selectors_1 = require("../common/selectors");
var loadCustomElementsRequest = identity_1.default;
var loadCustomElementsStart = identity_1.default;
var loadCustomElementsSuccess = function (state, action) {
    action.payload.elements.forEach(function (el) {
        var cacheKey = selectors_1.getElementCacheKey(state, el);
        if (!state.elements.cache[cacheKey]) {
            state.elements.cache[cacheKey] = el;
        }
    });
};
var loadCustomElementsError = identity_1.default;
var loadCustomElementsCancelRequest = identity_1.default;
var loadCustomElementsCancel = identity_1.default;
/**
 * @internal
 */
exports.loadCustomElementsReducers = {
    loadCustomElementsRequest: loadCustomElementsRequest,
    loadCustomElementsStart: loadCustomElementsStart,
    loadCustomElementsSuccess: loadCustomElementsSuccess,
    loadCustomElementsError: loadCustomElementsError,
    loadCustomElementsCancelRequest: loadCustomElementsCancelRequest,
    loadCustomElementsCancel: loadCustomElementsCancel,
};
//# sourceMappingURL=loadCustomElementsReducers.js.map